/* eslint-disable @typescript-eslint/naming-convention */

type EnumMap<T extends string> = Record<T, string>;

export const PET_SEX_TO_GQL = {
  male: 'MALE',
  female: 'FEMALE',
  unknown: 'UNKNOWN',
} as const satisfies EnumMap<'male' | 'female' | 'unknown'>;

export const PET_SEX_FROM_GQL = {
  MALE: 'male',
  FEMALE: 'female',
  UNKNOWN: 'unknown',
  male: 'male',
  female: 'female',
  unknown: 'unknown',
} as const;

export const CUSTOMER_STATUS_FROM_GQL = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  MERGED: 'merged',
  active: 'active',
  inactive: 'inactive',
  merged: 'merged',
} as const;

export const CATEGORY_KIND_TO_GQL = {
  product: 'PRODUCT',
  service: 'SERVICE',
  mixed: 'MIXED',
} as const satisfies EnumMap<'product' | 'service' | 'mixed'>;

export const CATEGORY_KIND_FROM_GQL = {
  PRODUCT: 'product',
  SERVICE: 'service',
  MIXED: 'mixed',
  product: 'product',
  service: 'service',
  mixed: 'mixed',
} as const;

export const CANCELLATION_SCOPE_FROM_GQL = {
  SALE: 'sale',
  ORDER_RETURN: 'order_return',
  INVOICE: 'invoice',
  OPEN_ACCOUNT: 'open_account',
  sale: 'sale',
  order_return: 'order_return',
  invoice: 'invoice',
  open_account: 'open_account',
} as const;

export const INVENTORY_MOVEMENT_KIND_TO_GQL = {
  purchase: 'PURCHASE',
  adjustment: 'ADJUSTMENT',
  sale: 'SALE',
  service_consumption: 'SERVICE_CONSUMPTION',
  kit_consumption: 'KIT_CONSUMPTION',
  restoration_on_cancel: 'RESTORATION_ON_CANCEL',
  surprise_count: 'SURPRISE_COUNT',
  transfer_in: 'TRANSFER_IN',
  transfer_out: 'TRANSFER_OUT',
} as const;

export const INVENTORY_MOVEMENT_KIND_FROM_GQL = {
  PURCHASE: 'purchase',
  ADJUSTMENT: 'adjustment',
  SALE: 'sale',
  SERVICE_CONSUMPTION: 'service_consumption',
  KIT_CONSUMPTION: 'kit_consumption',
  RESTORATION_ON_CANCEL: 'restoration_on_cancel',
  SURPRISE_COUNT: 'surprise_count',
  TRANSFER_IN: 'transfer_in',
  TRANSFER_OUT: 'transfer_out',
  purchase: 'purchase',
  adjustment: 'adjustment',
  sale: 'sale',
  service_consumption: 'service_consumption',
  kit_consumption: 'kit_consumption',
  restoration_on_cancel: 'restoration_on_cancel',
  surprise_count: 'surprise_count',
  transfer_in: 'transfer_in',
  transfer_out: 'transfer_out',
} as const;

export const KIT_ITEM_KIND_FROM_GQL = {
  PRODUCT: 'product',
  SERVICE: 'service',
  product: 'product',
  service: 'service',
} as const;

export const KIT_ITEM_KIND_TO_GQL = {
  product: 'PRODUCT',
  service: 'SERVICE',
} as const satisfies EnumMap<'product' | 'service'>;

export const USER_STATUS_TO_GQL = {
  active: 'ACTIVE',
  inactive: 'INACTIVE',
  suspended: 'SUSPENDED',
} as const satisfies EnumMap<'active' | 'inactive' | 'suspended'>;

export const USER_STATUS_FROM_GQL = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  SUSPENDED: 'suspended',
  active: 'active',
  inactive: 'inactive',
  suspended: 'suspended',
} as const;

export const OTP_ACTION_TO_GQL = {
  discount: 'DISCOUNT',
  sale_cancel: 'SALE_CANCEL',
  cash_out: 'CASH_OUT',
  cash_in: 'CASH_IN',
  admin_override: 'ADMIN_OVERRIDE',
} as const;

export const OTP_ACTION_FROM_GQL = {
  DISCOUNT: 'discount',
  SALE_CANCEL: 'sale_cancel',
  CASH_OUT: 'cash_out',
  CASH_IN: 'cash_in',
  ADMIN_OVERRIDE: 'admin_override',
  discount: 'discount',
  sale_cancel: 'sale_cancel',
  cash_out: 'cash_out',
  cash_in: 'cash_in',
  admin_override: 'admin_override',
} as const;

export const CASH_SHIFT_STATUS_TO_GQL = {
  open: 'OPEN',
  closed: 'CLOSED',
  locked: 'LOCKED',
} as const;

export const CASH_SHIFT_STATUS_FROM_GQL = {
  OPEN: 'open',
  CLOSED: 'closed',
  LOCKED: 'locked',
  open: 'open',
  closed: 'closed',
  locked: 'locked',
} as const;

export const CASH_MOVEMENT_KIND_FROM_GQL = {
  CASH_IN: 'cash_in',
  CASH_OUT: 'cash_out',
  SURPRISE_COUNT: 'surprise_count',
  cash_in: 'cash_in',
  cash_out: 'cash_out',
  surprise_count: 'surprise_count',
} as const;

export const OPEN_ACCOUNT_STATUS_TO_GQL = {
  open: 'OPEN',
  settled: 'SETTLED',
  transferred: 'TRANSFERRED',
  deceased: 'DECEASED',
  cancelled: 'CANCELLED',
} as const;

export const OPEN_ACCOUNT_STATUS_FROM_GQL = {
  OPEN: 'open',
  SETTLED: 'settled',
  TRANSFERRED: 'transferred',
  DECEASED: 'deceased',
  CANCELLED: 'cancelled',
  open: 'open',
  settled: 'settled',
  transferred: 'transferred',
  deceased: 'deceased',
  cancelled: 'cancelled',
} as const;

export const OPEN_ACCOUNT_KIND_TO_GQL = {
  normal: 'NORMAL',
  hospitalization_1: 'HOSPITALIZATION_1',
  hospitalization_2: 'HOSPITALIZATION_2',
} as const;

export const OPEN_ACCOUNT_KIND_FROM_GQL = {
  NORMAL: 'normal',
  HOSPITALIZATION_1: 'hospitalization_1',
  HOSPITALIZATION_2: 'hospitalization_2',
  normal: 'normal',
  hospitalization_1: 'hospitalization_1',
  hospitalization_2: 'hospitalization_2',
} as const;

export const OPEN_ACCOUNT_SETTLE_STATUS_TO_GQL = {
  settled: 'SETTLED',
  transferred: 'TRANSFERRED',
  deceased: 'DECEASED',
  cancelled: 'CANCELLED',
} as const;

export const OPEN_ACCOUNT_MOVEMENT_KIND_FROM_GQL = {
  CHARGE: 'charge',
  PAYMENT: 'payment',
  ADJUSTMENT: 'adjustment',
  REFUND: 'refund',
  charge: 'charge',
  payment: 'payment',
  adjustment: 'adjustment',
  refund: 'refund',
} as const;

export const OPEN_ACCOUNT_MOVEMENT_STATUS_FROM_GQL = {
  ACTIVE: 'active',
  CANCELLED: 'cancelled',
  active: 'active',
  cancelled: 'cancelled',
} as const;

export const SALE_ORDER_STATUS_TO_GQL = {
  created_by_cashier: 'CREATED_BY_CASHIER',
  sent_to_doctor_pending_take: 'SENT_TO_DOCTOR_PENDING_TAKE',
  taken_by_doctor: 'TAKEN_BY_DOCTOR',
  in_medical_attention: 'IN_MEDICAL_ATTENTION',
  returned_to_cashier_for_correction: 'RETURNED_TO_CASHIER_FOR_CORRECTION',
  sent_to_cashier_for_charge: 'SENT_TO_CASHIER_FOR_CHARGE',
  charged: 'CHARGED',
  draft: 'DRAFT',
  sent_to_cashier: 'SENT_TO_CASHIER',
  returned_to_doctor: 'RETURNED_TO_DOCTOR',
  pending_payment: 'PENDING_PAYMENT',
  paid: 'PAID',
  partially_paid: 'PARTIALLY_PAID',
  open_account: 'OPEN_ACCOUNT',
  cancelled: 'CANCELLED',
  voided: 'VOIDED',
  refunded: 'REFUNDED',
} as const;

export const SALE_ORDER_STATUS_FROM_GQL = {
  CREATED_BY_CASHIER: 'created_by_cashier',
  SENT_TO_DOCTOR_PENDING_TAKE: 'sent_to_doctor_pending_take',
  TAKEN_BY_DOCTOR: 'taken_by_doctor',
  IN_MEDICAL_ATTENTION: 'in_medical_attention',
  RETURNED_TO_CASHIER_FOR_CORRECTION: 'returned_to_cashier_for_correction',
  SENT_TO_CASHIER_FOR_CHARGE: 'sent_to_cashier_for_charge',
  CHARGED: 'charged',
  DRAFT: 'draft',
  SENT_TO_CASHIER: 'sent_to_cashier',
  RETURNED_TO_DOCTOR: 'returned_to_doctor',
  PENDING_PAYMENT: 'pending_payment',
  PAID: 'paid',
  PARTIALLY_PAID: 'partially_paid',
  OPEN_ACCOUNT: 'open_account',
  CANCELLED: 'cancelled',
  VOIDED: 'voided',
  REFUNDED: 'refunded',
  created_by_cashier: 'created_by_cashier',
  sent_to_doctor_pending_take: 'sent_to_doctor_pending_take',
  taken_by_doctor: 'taken_by_doctor',
  in_medical_attention: 'in_medical_attention',
  returned_to_cashier_for_correction: 'returned_to_cashier_for_correction',
  sent_to_cashier_for_charge: 'sent_to_cashier_for_charge',
  charged: 'charged',
  draft: 'draft',
  sent_to_cashier: 'sent_to_cashier',
  returned_to_doctor: 'returned_to_doctor',
  pending_payment: 'pending_payment',
  paid: 'paid',
  partially_paid: 'partially_paid',
  open_account: 'open_account',
  cancelled: 'cancelled',
  voided: 'voided',
  refunded: 'refunded',
} as const;

export const SALE_ORDER_ITEM_KIND_TO_GQL = {
  product: 'PRODUCT',
  service: 'SERVICE',
  kit: 'KIT',
  exception: 'EXCEPTION',
} as const;

export const SALE_ORDER_ITEM_KIND_FROM_GQL = {
  PRODUCT: 'product',
  SERVICE: 'service',
  KIT: 'kit',
  EXCEPTION: 'exception',
  product: 'product',
  service: 'service',
  kit: 'kit',
  exception: 'exception',
} as const;

export const SELLABLE_KIND_FROM_GQL = {
  PRODUCT: 'product',
  SERVICE: 'service',
  KIT: 'kit',
  product: 'product',
  service: 'service',
  kit: 'kit',
} as const;

export const INVOICE_STATUS_TO_GQL = {
  pending: 'Pending',
  stamping: 'Stamping',
  stamped: 'Stamped',
  cancel_requested: 'CancelRequested',
  cancelled: 'Cancelled',
  cancel_failed: 'CancelFailed',
  failed: 'Failed',
} as const;

export const INVOICE_STATUS_FROM_GQL = {
  Pending: 'pending',
  Stamping: 'stamping',
  Stamped: 'stamped',
  CancelRequested: 'cancel_requested',
  Cancelled: 'cancelled',
  CancelFailed: 'cancel_failed',
  Failed: 'failed',
  pending: 'pending',
  stamping: 'stamping',
  stamped: 'stamped',
  cancel_requested: 'cancel_requested',
  cancelled: 'cancelled',
  cancel_failed: 'cancel_failed',
  failed: 'failed',
} as const;

export const CFDI_CANCEL_MOTIVO_TO_GQL = {
  '01': 'M01',
  '02': 'M02',
  '03': 'M03',
  '04': 'M04',
} as const;

export const NOTIFICATION_AUDIENCE_TO_GQL = {
  cashier: 'Cashier',
  doctor: 'Doctor',
  admin: 'Admin',
  inventory: 'Inventory',
} as const;

export const NOTIFICATION_AUDIENCE_FROM_GQL = {
  Cashier: 'cashier',
  Doctor: 'doctor',
  Admin: 'admin',
  Inventory: 'inventory',
  cashier: 'cashier',
  doctor: 'doctor',
  admin: 'admin',
  inventory: 'inventory',
} as const;

export const NOTIFICATION_KIND_FROM_GQL = {
  OrderSentToCashier: 'order_sent_to_cashier',
  OrderReturnedToDoctor: 'order_returned_to_doctor',
  OrderCharged: 'order_charged',
  OrderCancelled: 'order_cancelled',
  CashDifference: 'cash_difference',
  OtpUsed: 'otp_used',
  LowStock: 'low_stock',
  order_sent_to_cashier: 'order_sent_to_cashier',
  order_returned_to_doctor: 'order_returned_to_doctor',
  order_charged: 'order_charged',
  order_cancelled: 'order_cancelled',
  cash_difference: 'cash_difference',
  otp_used: 'otp_used',
  low_stock: 'low_stock',
} as const;

export const SUSPICIOUS_KIND_FROM_GQL = {
  LargeDiscount: 'large_discount',
  FrequentReprint: 'frequent_reprint',
  CashDifference: 'cash_difference',
  large_discount: 'large_discount',
  frequent_reprint: 'frequent_reprint',
  cash_difference: 'cash_difference',
} as const;
